export interface DynamicYieldABData {
    choices: DynamicYieldABChoice[];
    cookies: DynamicYieldABCookie[];
}

export interface DynamicYieldABChoice {
    name: string;
    decisionId: string;
    variations: DynamicYieldABVariation[];
}

export interface DynamicYieldABVariation {
    type: string;
    data: any;
}

export interface DynamicYieldABCookie {
    name: string;
    value: string;
    maxAge: number;
}

export const useDynamicYieldStore = defineStore('dynamicYieldStore', () => {
    const cookies = ref<DynamicYieldABCookie[]>([]);
    const abChoices = ref<DynamicYieldABChoice[]>([]);

    async function fetchABChoices(pagePath: string) {
        const response = await useNuxtApp().$siteFetch<DynamicYieldABData>(`/dynamic-yield/ab/choose-variations?pagePath=${pagePath}`);

        if (!!response) {
            abChoices.value = response.choices;
            cookies.value = response.cookies;
        }

        return response;
    }

    function getChoiceBySelector(selector: string) {
        return abChoices.value?.find((choice) => choice.name === selector);
    }

    function getVariationBySelectorAndType(selector: string, type: string) {
        const choice = getChoiceBySelector(selector);

        return choice?.variations?.find((variation) => variation?.type === type);
    }

    function getCustomJSONVariationBySelector(selector: string) {
        return getVariationBySelectorAndType(selector, 'CUSTOM_JSON');
    }

    function $reset() {
        cookies.value = [];
        abChoices.value = [];
    }

    return { cookies, abChoices, getChoiceBySelector, getVariationBySelectorAndType, fetchABChoices, $reset };
});